import { FC, memo, useCallback } from "react";
import { Slider as MuiSlider, SxProps, Theme } from "@mui/material";
import styles from "./styles";

type Data = {
  value?: number | number[];
  range: {
    min: number;
    max: number;
    step: number;
  };
};

type Props = {
  name: string;
  data: Data;
  min: number;
  max: number;
  step: number;
  range?: boolean;
  sx?: SxProps<Theme>;
  onChange(name: string, data: Data): void;
};

const Slider: FC<Props> = ({ name, data, min, max, step, range, sx = {}, onChange }) => {
  const handleChange = useCallback((_: Event, value: number | number[]) => {
    const result = range
      ? {
          ...data,
          range: {
            min: (value as number[])[0],
            max: (value as number[])[1],
            step,
          },
        }
      : { ...data, value };
    onChange?.(name, result);
  }, [data, name, onChange, range, step]);

  return (
    <MuiSlider
      name={name}
      value={range ? [data.range.min, data.range.max] : data.value}
      min={min}
      max={max}
      step={step}
      valueLabelDisplay="on"
      onChange={handleChange}
      sx={{ ...styles.slider, ...sx }}
      className="RlxSlider"
    />
  );
};

Slider.displayName = "Slider";

export default memo(Slider);
